import { render, staticRenderFns } from "./HotBbsList.vue?vue&type=template&id=25e725a9&scoped=true"
import script from "./HotBbsList.vue?vue&type=script&lang=ts"
export * from "./HotBbsList.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./HotBbsList.vue?vue&type=style&index=0&id=25e725a9&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "25e725a9",
  "55037d68"
  
)

export default component.exports